import { COUNTRIES } from '@/../types/constants/countries';
/**
 * Converts a 2 character country ISO to the formatted name
 */
export function country(value: string): string {
	if(!value) return '';
	const country = COUNTRIES.find(c => c.value === value);
	if (country === undefined) return '';
	return country.text;
}